"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ProductDetailItem.js.map